module.exports = __webpack_public_path__ + "img/MaTsuhB-servie.10abe0e3.png";